module.exports = __webpack_public_path__ + "static/media/logo.0b44cec9.svg";